import {
    maxLength,
    minLength,
    required,
    sameAs,
} from 'vuelidate/lib/validators';

export const passwordValidation = {
    required,
    minLength: minLength(8),
    maxLength: maxLength(26),
    uppercase: (value: string): boolean => {
        return value.length ? /[A-Z]/.test(value) : true;
    },
    digit: (value: string): boolean => {
        return value.length ? /\d/.test(value) : true;
    },
    special: (value: string): boolean => {
        return value.length
            ? /[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/.test(value)
            : true;
    },
};

export default {
    password: {
        ...passwordValidation,
    },
    passwordAgain: {
        required,
        sameAs: sameAs('password'),
    },
};
